
import logger from "./../logger";
export default {
    showToast: () => {
        logger.log("Toastmaker not loaded yet")
    }
}